"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hash_1 = __importDefault(require("@emotion/hash"));
const get_safe_value_1 = __importDefault(require("./get-safe-value"));
let PREFIX = 'ub-';
function getClassNamePrefix() {
    return PREFIX;
}
exports.getClassNamePrefix = getClassNamePrefix;
function setClassNamePrefix(prefix) {
    PREFIX = prefix;
}
exports.setClassNamePrefix = setClassNamePrefix;
function getClassName(propertyInfo, value) {
    const { className, safeValue = false, complexValue = false } = propertyInfo;
    let valueKey;
    if (value === 'inherit' || value === 'initial' || value === 'unset') {
        valueKey = value;
    }
    else if (complexValue || value.includes('calc(')) {
        valueKey = hash_1.default(value);
    }
    else if (safeValue) {
        valueKey = value;
    }
    else {
        valueKey = get_safe_value_1.default(value);
    }
    return `${PREFIX}${className}_${valueKey}`;
}
exports.default = getClassName;
//# sourceMappingURL=get-class-name.js.map